import React from "react";
import {Badge, BadgeProps} from "@mui/joy";


interface NotificationAvatarBadgeProps extends BadgeProps {
    icon?: React.ReactNode;
    isRead?: boolean;
}


export const NotificationAvatarBadge = (
    {
        anchorOrigin = {
            vertical: 'bottom',
            horizontal: 'right',
        },
        badgeInset = '5%',
        size = 'sm',
        icon,
        isRead,
        ...props
    }: NotificationAvatarBadgeProps) => {
    const defaultSx = {
        '& .MuiBadge-badge': {
            backgroundColor: 'var(--select-option-hover-bg, #F4F5F8)',
            bottom: '6px',
            right: '-3px'
        },
        '--Badge-ringSize': '5px',
        '--Badge-paddingX': '0',
        '--Badge-ringColor': isRead ? 'var(--contextmenu-item-bg)' : 'var(--select-option-hover-bg, #F4F5F8)',
    };

    return (
        <Badge
            anchorOrigin={anchorOrigin}
            badgeInset={badgeInset}
            size={size}
            sx={defaultSx}
            badgeContent={icon}
            {...props}
        />
    );
};
